module.exports = __webpack_public_path__ + "img/redirect.e48b03ab.svg";